export const ConcentricCircles = () => {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="pattern-concentric-circles"
    >
      <circle cx="50.5" cy="50.5" r="49.5" stroke="currentColor" />
      <circle cx="50.8568" cy="50.8568" r="41.1766" stroke="currentColor" />
      <circle cx="50.5001" cy="50.5001" r="32.8532" stroke="currentColor" />
      <circle cx="50.1433" cy="50.1435" r="24.5297" stroke="currentColor" />
      <circle cx="49.8461" cy="49.8461" r="16.1469" stroke="currentColor" />
    </svg>
  )
}
